/**
 * Default http settings.
 * @author laci
 */
export default function (app) {
	app.config(['$httpProvider', function ($httpProvider) {
		$httpProvider.defaults.withCredentials = true;
	}]);
};
